import { Link } from "react-router-dom";
import { GeneralImage } from "../../../components";

interface CertificateCardProps {
  to: string;
  item: any;
}

const CertificateCard: React.FC<CertificateCardProps> = ({ to, item }) => {
  return (
    <>
      <div className="border-primary-bg relative min-w-40 shrink-0 overflow-hidden rounded-lg border transition-all hover:scale-95">
        <Link to={to}>
          <GeneralImage
            alt={item?.Name?.slice(0, 13)}
            src={item?.Image}
            className="h-36 rounded-t-xl"
            width="100%"
          />
          <div className="bg-primary-bg flex h-full flex-col gap-1 p-3 text-sm">
            <div className="flex justify-between font-bold">
              <span className="line-clamp-1 max-w-[65%] lg:max-w-[70%]">
                {item?.Name}
              </span>
              <span className="text-nowrap">{item?.Date}</span>
            </div>
            <div className="text-body-text flex flex-col gap-1">
              <span className="line-clamp-1">{item?.Authority}</span>
              <span className="line-clamp-2">{item?.Description}</span>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default CertificateCard;
